import { Ruler, Calculator, ReceiptText, ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const STEPS = [
  {
    icon: Ruler,
    step: "01",
    title: "Take-off",
    copy: "Upload architectural PDFs, set your scale, and measure lengths, areas and counts directly on the drawing.",
  },
  {
    icon: Calculator,
    step: "02",
    title: "Estimate",
    copy: "Turn quantities into priced estimates with your own rates and markups — no more spreadsheet juggling.",
  },
  {
    icon: ReceiptText,
    step: "03",
    title: "Billing",
    copy: "Generate applications for payment and track progress billing through to the final valuation.",
  },
];

export const HowItWorks = () => {
  return (
    <section
      id="how-it-works"
      data-testid="how-it-works-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16">
        <Reveal className="max-w-3xl">
          <p className="text-xs font-semibold tracking-[0.2em] uppercase text-brand-blue">
            How Trade Off works
          </p>
          <h2 className="mt-4 font-heading font-700 text-3xl sm:text-4xl lg:text-5xl tracking-tight text-brand-navy">
            From blueprint to billing in one workflow
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            Trade Off connects the three stages construction estimators repeat
            on every job — so the numbers flow through instead of being re-keyed.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
          {STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <Reveal key={s.step} delay={i * 0.1}>
                <div
                  data-testid={`how-step-${i}`}
                  className="relative h-full rounded-2xl border border-slate-200 bg-slate-50 p-8 hover:shadow-md hover:-translate-y-1 transition-all duration-300"
                >
                  <span className="font-heading font-800 text-5xl text-slate-200">
                    {s.step}
                  </span>
                  <div className="mt-4 inline-flex h-12 w-12 items-center justify-center rounded-xl bg-brand-navy text-white">
                    <Icon className="h-6 w-6" strokeWidth={2} />
                  </div>
                  <h3 className="mt-5 font-heading font-700 text-xl text-brand-navy">
                    {s.title}
                  </h3>
                  <p className="mt-3 leading-relaxed text-slate-600">{s.copy}</p>
                  {i < STEPS.length - 1 && (
                    <ArrowRight className="hidden md:block absolute top-1/2 -right-5 h-6 w-6 text-slate-300" />
                  )}
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
